import { render, staticRenderFns } from "./IdealPostcodesAutoComplete.vue?vue&type=template&id=be4f073e"
import script from "./IdealPostcodesAutoComplete.vue?vue&type=script&lang=js"
export * from "./IdealPostcodesAutoComplete.vue?vue&type=script&lang=js"
import style0 from "./IdealPostcodesAutoComplete.vue?vue&type=style&index=0&id=be4f073e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports